import React from 'react';
import { Square, Section } from '@grubhubprod/gh-cookbook-react/dist';

interface IPageSectionProps {
  children: JSX.Element | JSX.Element[];
  variant?: 'default' | 'rounded';
}

export default function PageSection({
  children,
  variant = 'default',
}: IPageSectionProps): JSX.Element {
  const sectionContent = <Section inset="md">{children}</Section>;

  if (variant === 'rounded') {
    return (
      <Square bg="untintedBackground" borderRadius="medium">
        {sectionContent}
      </Square>
    );
  }

  return (
    <Square
      dimension="1"
      bg="untintedBackground"
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderBottomColor="lightLine"
    >
      {sectionContent}
    </Square>
  );
}
